import { render, staticRenderFns } from "./HistoryProjectDialog.vue?vue&type=template&id=66a9a7c3&scoped=true"
import script from "./HistoryProjectDialog.vue?vue&type=script&lang=js"
export * from "./HistoryProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./HistoryProjectDialog.vue?vue&type=style&index=0&id=66a9a7c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a9a7c3",
  null
  
)

export default component.exports